
import './App.css';
import { Header } from './components';
import { AllRoutes } from './routes/Allroutes';

function App() {
  return (
    <div className="App">
      <Header/>
      <AllRoutes/>
    </div>
  );
}

export default App;
